import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';
import moment from 'moment-timezone';
import { DeviceControllerService } from 'src/app/shared/typescript-angular-client';

import { CommandService } from './command.service';

@Injectable({
  providedIn: 'root',
})
export class EventService extends CommandService {
  date: any;
  devicee: any;
  limit = false;
  offset: any;
  events: any;
  userId: any;
  data: any = [];
  lastEvent: any;
  dateStart: any;
  sendEvent: boolean;
  public finished = false;

  constructor(private siteDeviceApi: DeviceControllerService, private deviceApi: DeviceControllerService) {
    super(new ToastController());
  }

  sendMessage() {
    this.ble
      .writeWithoutResponse(this.device.bleId, this.device.serviceUUID, this.device.txUUID, this.hexTobytes(this.cmd))
      .then(
        (data) => {
          console.log('Result Write : ', data);
        },
        (err) => {
          console.log(err);
        }
      );
  }

  public InitData(device, lastEvent) {
    this.data = [];
    this.sendEvent = false;
    this.dateStart = new Date();
    console.log('Event device : ', device);
    const lastSync = device.properties.lastEvSync ? device.properties.lastEvSync : device.properties.lastSync;
    this.date = Math.floor(new Date(lastSync).valueOf() / 1000);
    this.cmd = '3f230800';
    this.limit = false;
    this.offset = 0;
    this.lastEvent = lastEvent;
    console.log('Last Event : ', lastEvent);

    this.deviceApi.GetLastEvent(this.device.id, lastSync).subscribe((res: any) => {
      console.log('GetLastEvent : ', res);
      this.userId = res.id;
      this.devicee = device;
      this.events = res;

      this.sendMessage();
    });
  }

  public async sendEventToApi() {
    return new Promise(async (resolve) => {
      console.log('Event Service - sendEventToApi:', this.data);
      if (this.data.length > 0) {
        console.log('Event Service - sending', this.data.length, 'events');
        /*this.data = [...new Map(this.data.map(item => [item['properties']['payload']['bytes']['data'], item])).values()];

              console.log("EVENT TO API : ", this.data);*/

        // await + toPromise + then??
        await this.siteDeviceApi
          .siteDeviceAddEventAll(this.device.id, this.data)
          .toPromise()
          .then((res) => {
            console.log(res);

            this.data = [];
            resolve(true);
          });
      } else {
        console.log('Event service - no events to send, end');
        resolve(true);
      }
    });
  }

  public async receiveResponse(data: any) {
    console.log('================== response event =====================');
    // console.log(this.buf2hex(data).toLowerCase());
    data = this.buf2hex(data).toLowerCase();

    if (data == '3a00') {
      return 'end';
    }

    data = data.slice(2, data.length);

    let i = parseInt(data.slice(0, 2), 16);
    let j = 0;
    let eventLength = 0;
    let offset = 0;
    data = data.slice(2, data.length);
    console.log('Data : ', data);
    console.log("Nombre d'itération : ", i);

    if (i == 0) {
      return 'end';
    }

    while (j < i) {
      eventLength = parseInt(data.slice(0 + offset, 2 + offset), 16) * 2;
      let currentEvent = data.slice(6 + offset, eventLength + offset);

      console.log('OFFESET : ', offset);
      console.log('Event Length : ', eventLength);
      console.log('currentEvent : ', currentEvent);

      if (currentEvent == 'ffff' || data == '' || data == null) {
        return 'end';
      }

      let date1 = this.littleToBigEndian(data.slice(2 + offset, 10 + offset));

      let frString = new Date(parseInt(date1, 16) * 1000).toISOString().replace('Z', '');
      let date2 = moment.tz(frString, 'Europe/Paris').unix();
      // var date2 = parseInt(date1, 16) - 3600;

      console.log('Date Event : ', date2);
      console.log('Date Last Sync : ', this.date);

      let eventType = data.slice(10 + offset, 12 + offset);

      if (date2 > this.date) {
        console.log('DateEvent > DateLastSync');

        let frTime = moment.tz(new Date(), 'Europe/Paris').unix();
        // console.log("DateEvent ", date2, " < ", Math.floor(new Date().getTime() / 1000) - 3600, " ? ", (date2 < Math.floor(new Date().getTime() / 1000) - 3600));
        if (date2 < frTime) {
          console.log('NOW : ', frTime);
          console.log('Verif Event : ', this.isPresentInArray(date2, eventType));
          console.log('evenType :  ', eventType);
          if (!this.isPresentInArray(date2, eventType)) {
            console.log('EventType : ', eventType);

            let body = {
              // userId: this.userId,
              deviceId: this.devicee.id,
              siteId: this.devicee.siteId,
              accessId: 0,
              properties: {
                type: null,
                level: null,
                payload: null,
                creationDate: new Date(date2 * 1000),
              },
            };

            switch (eventType) {
              case '02':
                body.properties.type = 'deviceController.intrusion';
                body.properties.payload = {};
                body.properties.level = 'alert';
                break;
              case '03':
                body.properties.type = 'deviceController.door_open';
                body.properties.payload = {};
                body.properties.level = 'alert';
                break;
              case '04':
                body.properties.type = 'deviceController.accessrefused';
                body.properties.payload = {
                  keyCardNumber: data.slice(12 + offset, eventLength + offset),
                };
                body.properties.level = 'alert';
                break;
              case '05':
                body.properties.type = 'deviceController.accessgranted';
                body.properties.payload = {
                  keyCardNumber: data.slice(12 + offset, eventLength + offset),
                };
                body.properties.level = 'info';
                break;
              case '06':
                body.properties.type = 'deviceController.wrongpin';
                body.properties.payload = {};
                body.properties.level = 'alert';
                break;
              case '07':
                body.properties.type = 'deviceController.acceptedpin';
                body.properties.payload = {
                  keyCardNumber: data.slice(12 + offset, eventLength + offset),
                };
                body.properties.level = 'info';
                break;
              case '08':
                body.properties.type = 'deviceController.keycardinversion';
                body.properties.payload = {};
                body.properties.level = 'alert';
                break;
              case '09':
                body.properties.type = 'deviceController.rfidloss';
                body.properties.payload = {};
                body.properties.level = 'info';
                break;
              case '0A':
                body.properties.type = 'deviceController.deletedkeycard';
                body.properties.payload = {
                  keyCardNumber: data.slice(12 + offset, eventLength + offset),
                };
                body.properties.level = 'alert';
                break;
              case '0B':
                body.properties.type = 'deviceController.resetwatchdog';
                body.properties.payload = {};
                body.properties.level = 'alert';
                break;
              case '0C':
                body.properties.type = 'deviceController.presencepush';
                body.properties.payload = {};
                body.properties.level = 'alert';
                break;
              case '0D':
                body.properties.type = 'deviceController.hardfault';
                body.properties.payload = {
                  pointer: data.slice(12 + offset, 12 + offset + 4),
                  function: data.slice(12 + offset, eventLength + offset),
                };
                body.properties.level = 'alert';
                break;

              default:
                console.log('EventService - unknown event type:', eventType);
                break;
            }

            if (eventType != '09') {
              this.data.push(body);
              console.log('current data : ', this.data);
            }
          }
        }
      }

      if (date2 < this.date || this.offset == 255) {
        this.limit = true;
        console.log('DATE ANTERIEUR');
        console.log('[EVENT END] Temps écoulé : ', new Date().getTime() - this.dateStart.getTime());
        console.log('Offset : ', this.offset);
        console.log('Data ; ', this.data);

        return 'end';
      }

      j += 1;
      offset += eventLength + 2;
    }

    console.log('END : ', this.limit);

    if (!this.limit) {
      this.offset = this.offset + i;

      if (this.offset > 255) {
        this.offset = 255;
      }
      this.cmd = '3f2308' + this.decToHex(this.offset);
      this.sendMessage();
    } else {
      this.finished = true;
      return 'end';
    }
  }

  decToHex(value) {
    value = value.toString(16);

    if (value.length == 1) {
      return '0' + value;
    }
    return value;
  }

  isPresentInArray(date, eventType) {
    for (const item of this.events) {
      let d = Math.floor(new Date(item.properties.creationDate).valueOf() / 1000);
      if (d == date) {
        if (eventType == '02' && item.properties.type == 'deviceController.intrusion') {
          return true;
        }
        if (eventType == '03' && item.properties.type == 'deviceController.door_open') {
          return true;
        }
        if (eventType == '04' && item.properties.type == 'deviceController.accessrefused') {
          return true;
        }
        if (eventType == '05' && item.properties.type == 'deviceController.accessgranted') {
          return true;
        }
        if (eventType == '06' && item.properties.type == 'deviceController.wrongpin') {
          return true;
        }
        if (eventType == '07' && item.properties.type == 'deviceController.acceptedpin') {
          return true;
        }
        if (eventType == '08' && item.properties.type == 'deviceController.keycardinversion') {
          return true;
        }
        if (eventType == '09' && item.properties.type == 'deviceController.presencepush') {
          return true;
        }
        if (eventType == '0A' && item.properties.type == 'deviceController.deletedkeycard') {
          return true;
        }
        if (eventType == '0B' && item.properties.type == 'deviceController.resetwatchdog') {
          return true;
        }
      }
    }
    return false;
  }
}
